import React, { ReactNode } from 'react';
import { BadgeWithTooltip } from '../../../../ui/AvatarTool/BadgeWithTooltip/BadgeWithTooltip';
import classes from './FieldTooltipBadge.module.scss';

interface FieldTooltipBadgeProps {
  id: string
  title: string
  content: string
  children: ReactNode
}

// Mirrors MemoryForm's own .lockedTooltip pattern: the field renders untouched, and the badge is
// a sibling pinned to its top-right corner -- never inline with the label text.
export function FieldTooltipBadge(props: FieldTooltipBadgeProps) {
  const {
    id, title, content, children,
  } = props;
  return (
    <div className={classes.wrapper}>
      {children}
      <div className={classes.badge}>
        <BadgeWithTooltip id={id} title={title} content={content} />
      </div>
    </div>
  );
}
